import { gh, isExecute, vueDefineComponent } from '@syncfusion/ej2-vue-base';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
export let ChartsDirective = vueDefineComponent({
    inject: { custom: { default: null } },
    render(createElement) {
        if (!isExecute) {
            let h = !isExecute ? gh : createElement;
            let slots = null;
            if (!isNullOrUndefined(this.$slots.default)) {
                slots = !isExecute ? this.$slots.default() : this.$slots.default;
            }
            return h('div', { class: 'e-directive' }, slots);
        }
        return;
    },
    updated() {
        if (!isExecute && this.custom) {
            this.custom();
        }
    },
    methods: {
        getTag() {
            return 'e-charts';
        }
    }
});
export const ChartsPlugin = {
    name: 'e-charts',
    install(Vue) {
        Vue.component(ChartsPlugin.name, ChartsDirective);
    }
};
export let ChartDirective = vueDefineComponent({
    render() {
        return;
    },
    methods: {
        getTag() {
            return 'e-chart';
        }
    }
});
export const ChartPlugin = {
    name: 'e-chart',
    install(Vue) {
        Vue.component(ChartPlugin.name, ChartDirective);
    }
};
